module.exports = __webpack_public_path__ + "img/SCB.3d8e5414.png";